import { render, staticRenderFns } from "./DocumentsToAcknowledge.vue?vue&type=template&id=420217a6&scoped=true&"
import script from "./DocumentsToAcknowledge.vue?vue&type=script&lang=js&"
export * from "./DocumentsToAcknowledge.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsToAcknowledge.vue?vue&type=style&index=0&id=420217a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420217a6",
  null
  
)

export default component.exports